const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/SERVICES') => `${reducer}/${actionType}`;

export const exampleActionX = () => {
	return async (dispatch, getState) => {
		//CUSTOM ACTION
		await dispatch({
			type: generateType('CUSTOM'),
			payload: { ...getState().organism.page },
		});
		//SET ACTION
		await dispatch({
			type: generateType('SET'),
			payload: { scope: '', values: {} },
		});
		//CLEAR ACTION
		await dispatch({
			type: generateType('CLEAR'),
			payload: { scope: '', values: {} },
		});
	};
};
